import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[fi-contenteditable-simple-text-panel-root]',
    standalone: false,
})
export class FiContenteditableSimpleTextPanelRootDirective {
    currentViewContainerRef: ViewContainerRef;

    setCurrentViewContainerRef(viewRef: ViewContainerRef) {
        this.currentViewContainerRef = viewRef;
    }
}
